import { useDispatch } from 'react-redux';

import { updateFeatureSet } from 'modules/app/layout/redux/actions';
import {
  useMutation,
  type MutationState,
} from 'src/core/api/hooks/useMutation';
import type FEATURES from 'src/core/constants/features';

export const useDisableFeature = (featureCode: FEATURES): MutationState => {
  const dispatch = useDispatch();
  return useMutation<
    void,
    {
      featureSet: FEATURES;
    }
  >({
    request: {
      type: 'rest',
      method: 'delete',
      target: 'companyAPI',
      endpoint: `/feature/${featureCode}`,
    },
    reshapeData: (data) => {
      return data.featureSet;
    },
    options: {
      throwOnError: true,
      onSuccess({ data }): void {
        dispatch(updateFeatureSet(data));
      },
    },
  });
};
